import "core-js/modules/es.array.reduce.js";
import BuyWorkModal from '@/frontend/modals/BuyWorkModal';
import WorksApi from '@/frontend/api/works';
import { ref, onMounted, watch, markRaw } from 'vue';
import { mapGetters } from 'vuex';
import { ElMessage, ElCollapse, ElLoading } from "element-plus";
import { useRoute } from "vue-router";
import 'element-plus/es/components/message/style/css';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
import setMetas from '@/frontend/functions/setMetas';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
import Yandex from "@/frontend/classes/yandex";
export default {
  name: "WorkPage",
  components: {
    ElCollapse,
    WorkCardComponent
  },

  setup() {
    const tab = ref(null);
    const ul = ref(null);
    const workTab = ref(null);
    const router = useRoute();
    onMounted(() => {
      watch(() => [tab, ul], () => {
        if (tab.value && ul.value && window.tabsInit) window.tabsInit(tab.value, ul.value);
      }, {
        deep: true,
        immediate: true
      });
      watch(router, () => {
        workTab.value.click();
      });
    });
    return {
      tab,
      ul,
      workTab
    };
  },

  data() {
    return {
      Work: {},
      Works: [],
      fullDesc: false,
      moreBlock: false,
      descSymbolMax: 530,
      initialIndexViewer: 0
    };
  },

  computed: { ...mapGetters(['modalResult']),

    description() {
      if (!this.Work.description) return [''];
      if (this.fullDesc) return this.Work.description.split('\r\n');
      return this.Work.description.length > this.descSymbolMax ? this.Work.description.slice(0, this.descSymbolMax).split('\r\n') : this.Work.description.split('\r\n');
    },

    descriptionAuthor() {
      if (!this.Work.author || !this.Work.author.description) return [''];
      return this.Work.author.description.split('\r\n');
    },

    city() {
      let result;
      if (!this.Work.author || !this.Work.author.year_life && !this.Work.author.year_death) return '';
      if (this.Work.author.year_life && this.Work.author.year_death) result = this.Work.author.year_life + ' - ' + this.Work.author.year_death;else result = this.Work.author.year_life || this.Work.author.year_death;
      return result;
    },

    previewList() {
      if (this.Work.imagesWorks) return [this.Work.imageWithPath].concat(this.Work.imagesWorks.map(item => item.imageWithPath));
      return [this.Work.imageWithPath];
    }

  },
  watch: {
    modalResult(result) {
      if (result.type === 'success') {
        this.$nextTick(() => {
          let loader = ElLoading.service({
            text: 'Загрузка'
          });
          this.$store.dispatch('resultModal', {});
          WorksApi.requestBuy(this.Work.id, result.data).then(response => {
            ElMessage.success(response.message);
            Yandex.metrika('reachGoal', 'itsok8');
          }).catch(handlerErrorRequest).finally(() => loader.close());
        });
      }
    },

    $route() {
      this.$route.name === 'work' && this.init();
    }

  },

  created() {
    setMetas('work');
    this.init();
  },

  methods: {
    openBuyModal() {
      this.$store.dispatch('modal', {
        component: markRaw(BuyWorkModal),
        options: {
          dialog: {
            visible: true
          }
        }
      });
    },

    openImageViewer(index) {
      this.initialIndexViewer = index;
      this.$refs.triggerPreview && this.$refs.triggerPreview.$el.children[0].click();
    },

    init() {
      WorksApi.get({
        expand: 'author,imagesWorks'
      }, this.$route.params.id).then(response => {
        this.Work = response;
        this.moreBlock = this.Work.description && this.Work.description.length > this.descSymbolMax;
        WorksApi.getSimilarAuthor(this.Work.author.id, {
          'per-page': 3,
          'workId': this.Work.id,
          'expand': ['author'].join(',')
        }).then(response => {
          this.Works = response.items;
          this.Works.forEach(value => {
            value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
          });
        });
      }).catch(() => this.$router.push({
        name: 'not-found'
      }));
    }

  }
};